import TWEEN from "@tweenjs/tween.js";
import { Entity } from "ecsy";

export const tweenSystemExecute = (
  time: number,
  qrTween: Entity[]) => {
  TWEEN.update(time);
};
